import { memo, useEffect, useState } from 'react';
import { useMapContext } from '../../hooks';
/**
 * Добавить полупрозрачный слой на карту между картой и слоем машин
 */
var pngs = {
    '20': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6bwwAAjoBNT578agAAAAASUVORK5CYII=',
    '40': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8nwYAAmoBZ0eMiB8AAAAASUVORK5CYII=',
    '60': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8PxMAAp0BmiC7I60AAAAASUVORK5CYII=',
    '80': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8fwYAAtABzbrmHzgAAAAASUVORK5CYII='
};
var MoodyLayer = function (_a) {
    var opacity = _a.opacity, _b = _a.zIndex, zIndex = _b === void 0 ? 160 : _b;
    var map = useMapContext();
    var layer = useState(function () {
        return new ymaps.Layer(pngs[opacity], {
            tileTransparent: true,
            zIndex: zIndex
        });
    })[0];
    useEffect(function () {
        map.layers.add(layer);
        return function () {
            map.layers.remove(layer);
        };
    }, [layer, map]);
    useEffect(function () {
        layer.setTileUrlTemplate(pngs[opacity]);
        layer.update();
    }, [layer, opacity]);
    return null;
};
export default memo(MoodyLayer);
